export default class NavLink extends HTMLElement {
  constructor() {
    super();

    if (!this.linkEl || !this.linkPath || this.linkHasAriaCurrent) return;

    if (this.linkIsCurrent) {
      this.linkEl.setAttribute("aria-current", "page");
    } else if (this.ancestorIsCurrent) {
      this.linkEl.classList.add("is-current");
    }
  }

  get linkEl() {
    return this.querySelector("a");
  }

  get linkHasAriaCurrent() {
    const ariaCurrent = this.linkEl.getAttribute("aria-current");
    return ariaCurrent === "page";
  }

  get linkPath() {
    if (!this.linkEl.href) return null;
    const url = new URL(this.linkEl.href);
    return url.pathname;
  }

  get currentPath() {
    const url = new URL(window.location);
    return url.pathname;
  }

  get linkIsCurrent() {
    return this.linkPath === this.currentPath;
  }

  get ancestorIsCurrent() {
    if (this.currentPath.startsWith(this.linkPath)) return true;
    if (
      this.isProductOrCollection(this.linkPath) &&
      this.isProductOrCollection(this.currentPath)
    )
      return true;
    return false;
  }

  isProductOrCollection(pathname) {
    return (
      pathname.startsWith("/products/") || pathname.startsWith("/collections/")
    );
  }
}
